import React from 'react'
import { Link } from 'react-router-dom'
import { Layout, Text } from '../../components'
import { FormattedMessage } from 'react-intl'
import { useIsSuperEnabledFromUrl } from '../../utils'

export function NotFound() {
  const superEnabled = useIsSuperEnabledFromUrl()
  return (
    <Layout superEnabled={superEnabled}>
      <div className="flexbox flexbox-column flexbox-align-center content-main">
        <div className="flexbox flexbox-column flexbox-align-center flexbox-centered">
          <div className="font-family-title font-size-larger font-weight-medium margin-bottom-16">
            <FormattedMessage
              id="boarding.notFoundPage.title"
              defaultMessage="We couldn’t find the page you’re looking for."
              values={{}}
            />
          </div>
          <div className="flexbox flexbox-centered">
            <div className="flexbox flexbox-centered font-weight-bold">
              <Link
                to="/"
                className="radius-normal flexbox background-primary white bold flexbox-align-center flexbox-justify-center margin-vertical-16 padding-horizontal-32 padding-vertical-12 position-relative"
              >
                <FormattedMessage
                  id="boarding.notFoundPage.button"
                  defaultMessage="Go back home"
                  values={{}}
                />
              </Link>
            </div>
          </div>
          <div
            className="text-align-center font-weight-medium shade-10 margin-bottom-12"
            style={{ maxWidth: 400 }}
          >
            <FormattedMessage
              id="boarding.notFoundPage.description"
              defaultMessage="The page you’re asking for doesn’t seem to exist. Please check you
            have the right link and <link>Contact us</link> if this error persists."
              values={{
                link: (text: React.ReactNode) => (
                  <Text.ExternalLink inline href="mailto:contact@slite.com">
                    {text}
                  </Text.ExternalLink>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}
